import { Button, Col, Modal, Row } from 'antd';
import React, { ReactElement } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';

const AutoPopulateProcedures = ({ claimDetail, visible, handleProceed, handleSkip }: any): ReactElement => {
  const { selectedBeneficiaryDetail }: any = useSelector((state: RootState): NewAdmissionState => state?.newAdmission || {});
  const procedure = claimDetail?.procedureDesc[0]?.payerMasterValue || 'some treatment';
  return (
    <React.Fragment>
      <Modal
        visible={visible}
        onOk={handleProceed}
        onCancel={handleSkip}
        className="auto-populate-procedure"
        footer={
          <Row justify="end">
            <Col>
              <Button key="back" danger={true} onClick={handleSkip}>
                <p id="WA_AUTO_POPULATE_SKIP">Skip</p>
              </Button>
            </Col>
            &nbsp;
            <Col>
              <Button key="submit" type="primary" onClick={handleProceed}>
                <p id="WA_AUTO_POPULATE_PROCEED">Proceed</p>
              </Button>
            </Col>
            &nbsp;
          </Row>
        }
      >
        <h3>
          <strong>
            <span className="mr-5">
              {selectedBeneficiaryDetail
                ? selectedBeneficiaryDetail?.memberName
                : 'Member'}
            </span>
            was previously admitted for {procedure?.toLowerCase()}. Do you want
            to use the same details ?
          </strong>
        </h3>
        <div>
          If yes please click on Proceed. If you want a new form then please
          skip.
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default AutoPopulateProcedures;
